import { Component, OnInit, Inject } from '@angular/core';
import { XPRESS_FUNDING_SOURCESFUNDING_SOURCE, XPRESS_FUNDING_SOURCESFUNDING_SOURCEBank_account_type, XPRESS_FUNDING_SOURCESFUNDING_SOURCEFunding_type } from 'src/models/xpress_loan.model';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA , MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ApiService } from 'src/shared/api.service';
import * as _ from 'lodash';
import { ConfirmationDialog } from 'src/components/confirmation-dialog/confirmation-dialog.component';
import { AppComponent } from 'src/app/app.component';
import { Util } from 'src/shared/util';

@Component({
  selector: 'app-bank-form',
  templateUrl: './bank-form.component.html',
  styleUrls: ['./bank-form.component.css']
})
export class BankFormComponent implements OnInit {
  AppComponent = AppComponent;
  fundingSource: XPRESS_FUNDING_SOURCESFUNDING_SOURCE = {} as any;
  bankAccountTypes = XPRESS_FUNDING_SOURCESFUNDING_SOURCEBank_account_type;

  public states = [];
  public bankForm: FormGroup;
  invalidRoutingNumnerMsg = "";

  validationErrors = {} as any;
  isValidForm = true;
  isCheckFormValid = false;

  constructor(
    private fb: FormBuilder,
    private apiService: ApiService,
    public dialogRef: MatDialogRef<BankFormComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog : MatDialog
    ) {
    this.fundingSource.funding_type = XPRESS_FUNDING_SOURCESFUNDING_SOURCEFunding_type.BANK;
    if(data.existingBank){
      this.fundingSource = data.existingBank;
    }

    var fundingLog = {
      appId : this.data.submitHistory.XAId,
      submitHistoryId : this.data.submitHistory.id,
      appEvent : this.data.existingBank ?"Open create bank" : "Open edit bank",
      accountHolderName : this.data.existingBank?.bank_name_on_card.split(' ')
      .map((word, index) => index === 0 ? word : word.replace(/./g, '*'))
      .join(' '),
      routingNumber : this.data.existingBank?.routing_number ?? "",
      accountNumber:  this.data.existingBank?.bank_account_number ? 
          this.data.existingBank?.bank_account_number.slice(-4).padStart(this.data.existingBank?.bank_account_number?.length, '*') : "",
      bankAccountType : this.data.existingBank?.bank_account_type
    } as any;
    try{
      this.apiService.saveFundingLog(fundingLog).subscribe(r=>{})
    }catch{}  

   }

  ngOnInit(): void {
    this.bankForm = this.fb.group({
      bankAccountType: ['', [Validators.required]],
      bank_name_on_card: ['', [Validators.required]],
      bank_account_number: ['', Validators.required],
      routing_number: ['', [Validators.required, Validators.pattern('^[0-9]{9}$')]],
      bank_bankname: ['', [Validators.required, Validators.maxLength(30), Validators.pattern(/^[A-Za-z0-9\s-]+$/)]],
      bank_bankstate: ['', [Validators.required, Validators.pattern(/^[A-Za-z]{2}$/)]],
    })

    this.getStates();

    this.bankForm.valueChanges.subscribe(() => {
      if (this.bankForm.valid) {
        const formData = this.bankForm.value;
        const fundingLog = {
          appId: this.data.submitHistory.XAId,
          submitHistoryId: this.data.submitHistory.id,
          appEvent: "Completed input bank form",
          accountHolderName: formData.bank_name_on_card.split(' ')
            .map((word, index) => index === 0 ? word : word.replace(/./g, '*'))
            .join(' '),
          routingNumber: formData.routing_number,
          accountNumber: formData.bank_account_number
            .slice(-4)
            .padStart(formData.bank_account_number.length, '*'),
          bankAccountType: formData.bankAccountType
        };
        try {
          this.apiService.saveFundingLog(fundingLog).subscribe(r => {});
        } catch (error) {
        }
      }
    });
    

  }

  ngAfterViewInit(){
    this.bankForm.statusChanges.subscribe(() => {
      if(this.isCheckFormValid){
        this.checkBankFormValid();
      }  
    });
  }

  checkBankFormValid(){
    _.each(this.bankForm.controls, (c) => {
      const controlName = Util.getControlName(c);
        // if (controlName === 'bank_bankstate') {
        //   return;
        // }
      if (c.errors) {
        this.validationErrors[`bankform;${controlName}`] = c.errors;
      } else {
        delete this.validationErrors[`bankform;${controlName}`];
      }
    });  
  }



  public submit(): void {
    this.isCheckFormValid = true;
    this.isValidForm = true;
    _.forOwn(this.validationErrors, (value, key) => {
      if (value) {
        this.isValidForm = false;
      }
    });
    this.checkBankFormValid();
    // Check if user has manually entered bank details
    const hasManualEntry = this.fundingSource.bank_bankname && this.fundingSource.bank_bankstate;
    
    if(hasManualEntry){
      this.invalidRoutingNumnerMsg = ''; // Clear the error message
      console.log('Manual entry detected - clearing error message and allowing submission');
    }
    
    // Skip error message validation if user has manually entered data
    const shouldCheckErrorMessage = !hasManualEntry;
    
    if(!this.isValidForm || (shouldCheckErrorMessage && this.invalidRoutingNumnerMsg) || this.bankForm.invalid){
      return;
    }
    this.dialogRef.close(this.fundingSource)
  }

  // getBank(){
    // this.invalidRoutingNumnerMsg = "";
    // if(!this.fundingSource.routing_number){
    //   return;
    // }
    
    // // Validate routing number format (9 digits)
    // if (!/^\d{9}$/.test(this.fundingSource.routing_number)) {
    //   this.invalidRoutingNumnerMsg = "Routing number must be exactly 9 digits.";
    //   return;
    // }
    
    // this.apiService.getBank(this.fundingSource.routing_number).subscribe(r=>{
    //   if(r && r.customer_name && !r.error){
    //     // Fed service returned bank info
    //     this.fundingSource.bank_bankname = r.customer_name;
    //     this.fundingSource.bank_bankstate = r.state;
    //     this.invalidRoutingNumnerMsg = "";
    //   } else if (r && r.error === 'FED_SERVICE_DOWN' && r.allowManualEntry) {
    //     // Fed service is down, allow manual entry
    //     this.invalidRoutingNumnerMsg = "Bank lookup service unavailable. Please enter bank details manually.";
    //     // Clear the fields to allow manual entry
    //     this.fundingSource.bank_bankname = '';
    //     this.fundingSource.bank_bankstate = '';
    //   } else {
    //     this.invalidRoutingNumnerMsg = "Invalid Routing Number.";
    //   }

    // }, err=>{
    //   // If API completely fails, allow manual entry
    //   this.invalidRoutingNumnerMsg = "Bank lookup service unavailable. Please enter bank details manually.";
    //   this.fundingSource.bank_bankname = '';
    //   this.fundingSource.bank_bankstate = '';
    // });
  // }

  getStates(){
    this.apiService.getStates().subscribe( r => {
      this.states = r;
    })
  }

  checkBankState(a){
    var temp = _.find(this.states,i => i.value.toUpperCase() == a.toUpperCase())
    if (temp) {
      this.bankForm.controls["bank_bankstate"].setErrors(null);
    }else{
       this.bankForm.controls["bank_bankstate"].setErrors({'incorrect': false});
    }
  }

  openConfirmClose(){
    this.dialog.open(ConfirmationDialog, {
      panelClass: AppComponent.isDesktop ? 'col-md-4' : 'full-screen',
      scrollStrategy:  AppComponent.scrollStrategy,
      data:{
        confirmMessage :"Are you sure you want to close it?"
      },
      autoFocus: true,
      disableClose: true
    }).afterClosed().subscribe(res => {
      if (res === true) {
          this.dialogRef.close()
      }
  })
  }

  // setupProductTypeConfig(productType){
  //   this.productTypeConfig = this.jsonConfig[`productType${productType}`];
  //   for (const key of Object.keys(this.productTypeConfig)) {
  //     const control = this.bankForm.controls[key];
  //     const config = this.productTypeConfig[key];
  //     const cloneControl = this.cloneBankForm.controls[key];
  //     if (control && config) {
  //       config.disabled ? control.disable() : control.enable();
  //       if (!config.required) {
  //         control.clearValidators();
  //       }else{
  //         if (!cloneControl.validator) {
  //           cloneControl.validator = [Validators.required];
  //         }else if(!cloneControl.hasValidator(Validators.required)){
  //           cloneControl.validator = [cloneControl.validator,Validators.required];
  //         }
  //         control.setValidators(cloneControl.validator);   
  //       }
  //       control.updateValueAndValidity();
  //       if(config.defaultValue && config.defaultValue != null && config.defaultValue != undefined && !this.isReviewing){
  //         control.setValue(config.defaultValue);
  //       }
  //     }
  //   }
  // }
}
